export default function makeSrcWithProtocol(src: string) {
  return src.startsWith("//") ? `https:${src}` : src;
}
